const i18n = {
  'home_welcome': 'PGU BZH welcome!',
  'home_title_mutations': 'Mutations',
  'label_select-language': 'Change language',
  'select-language_br': 'Breton',
  'select-language_en': 'English',
  'select-language_fr': 'French',
  'action-apply-mutations': 'Review',
  'label-with-mutations': 'with mutations',
  'label-without-mutations': 'without mutations',
  'ADJECTIVE_POSSESSIVE': 'ap - Adjectif possessif',
  'ADJECTIVE_QUALIFICATIVE': 'aq - Adjectif qualificatif',
  'ADVERB': 'av - Adverbe',
  'ARTICLE': 'ar - Article',
  'CARDINAL_BEFORE_SUBSTANTIF': 'ca - Cardinal devant un substantif',
  'COMPARATIVE': 'cp - Comparative',
  'CONJUNCTION_COORDINATING': 'cc - Conjonction de coordination',
  'CONJUNCTION_SUBORDINATE': 'cs - Conjonction de subordination',
  'ORDINAL': 'or - Ordinal',
  'OTHER': '- - non qualifié',
  'PARTICLE_VERBAL': 'pv - Particule verbale',
  'PREPOSITION': 'pn - Préposition',
  'PRONOUN': 'pr - Pronom',
  'PRONOUN_PERSONAL': 'pp - Pronom personnel',
  'PRONOUN_POSSESSIVE': 'ps - Pronom possessive',
  'NOUN': 'ns - Nom / Substantif',
  'NUMBER': 'nb - Nombre',
  'VERB': 'vb - Verbe',
  'MASCULINE': 'M',
  'FEMININE': 'F',
  'SINGULAR': 'S',
  'PLURAL': 'P',
  'PEOPLE': 'People',
  'is-reference': 'ref',
  'modal_title_soft': 'Soft',
  'modal_title_hard': 'Hard',
  'modal_title_mixed': 'Mixed',
  'modal_title_spirante': 'Spirante',
  'modal_title_incomplete': 'Incomplete',
  'modal_title_soft_incomplete': 'Soft incomplete',
  'modal_title_soft_conditional': 'Soft conditional',
  'mutations_in_songs_title': 'Mutations in songs',
};

export default i18n;
